import request from "@/utils/request";
import axios from "axios";
import { getToken } from "@/utils/auth";

// 管理员登录
export function login(data) {
  return request({
    url: "/login",
    method: "post",
    data,
  });
}

// 获取管理员信息
export function getInfo() {
  return request({
    url: "/admin_info",
    method: "get",
  });
}

// 修改管理员密码 - 直接使用完整URL
export function changePassword(data) {
  const token = getToken();
  return axios({
    url: "https://jqapi.66833089.com/api/admin/change_password",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  })
    .then((response) => {
      const res = response.data;

      // 检查响应状态
      const isSuccess = res.success === true || res.code === 200;

      if (!isSuccess) {
        const errorMessage = res.message || "修改密码失败";
        throw new Error(errorMessage);
      }

      return res;
    })
    .catch((error) => {
      if (error.response) {
        const { status, data } = error.response;
        const errorMessage = data?.message || `请求失败 (${status})`;
        throw new Error(errorMessage);
      } else if (error.request) {
        throw new Error("网络连接失败，请检查网络设置");
      } else {
        throw new Error(error.message || "修改密码失败");
      }
    });
}

// 退出登录 - JWT系统不需要服务端logout，直接在前端清除token即可
// export function logout() {
//   return request({
//     url: '/logout',
//     method: 'post'
//   })
// }
